/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CsatLineChart_answersReport = {|
  +csatByDate: ?$ReadOnlyArray<?{|
    +date: ?string;
    +positive: ?number;
    +total: ?number;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CsatLineChart_answersReport",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "CsatByDate",
      "name": "csatByDate",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "date",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "positive",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "total",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswersReport"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/CsatLineChart/__generated__/CsatLineChart_answersReport.graphql.js